import React, { useEffect, useRef, useState } from 'react';
import {
	Button,
	ClickAwayListener,
	IconButton,
	Paper,
	Popover,
	Stack,
	TextField,
	useTheme,
} from '@mui/material';
import { useCurrentEditor } from '@tiptap/react';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import LinkMenu from '../Menus/LinkMenu';

const ToolbarLinkButton = () => {
	const { editor } = useCurrentEditor();

	const [anchorEl, setAnchorEl] = useState(null);
	const [url, setUrl] = useState('');
	const inputRef = useRef(null);

	const isActive = editor?.isActive('link');

	const handleOpen = (event) => {
		setAnchorEl(event.currentTarget);

		const existing = editor?.getAttributes('link')?.href ?? '';
		setUrl(existing);
	};

	const handleClose = () => {
		setUrl('');
		setAnchorEl(null);
	};

	const handleSubmit = () => {
		if (!url) {
			editor.chain().focus().unsetLink().run();
			handleClose();
			return;
		}

		editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
		handleClose();
	};

	useEffect(() => {
		if (anchorEl && inputRef.current) {
			setTimeout(() => inputRef.current?.focus(), 50);
		}
	}, [anchorEl]);

	const open = Boolean(anchorEl);

	return (
		<>
			<IconButton
				size='small'
				onClick={(e) => {
					if (isActive) {
						return editor.chain().focus().unsetLink().run();
					}
					handleOpen(e);
				}}
				sx={{ transform: 'rotate(45deg)' }}
				className={isActive ? 'active' : ''}
			>
				<InsertLinkIcon />
			</IconButton>
			{open && (
				<Popover
					open={open}
					anchorEl={anchorEl}
					onClose={handleClose}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					sx={{
						zIndex: (theme) => theme.zIndex.modal + 20,
					}}
				>
					<ClickAwayListener onClickAway={handleClose}>
						<div>
							<LinkMenu
								{...{
									url,
									setUrl,
									inputRef,
									onSubmit: handleSubmit,
									onRemove: () => {
										editor.chain().focus().unsetLink().run();
										handleClose();
									},
									isActive,
								}}
							/>
						</div>
					</ClickAwayListener>
				</Popover>
			)}
		</>
	);
};
export default ToolbarLinkButton;
